/**
 * Compute exchange rate "1 base = X quote" using scaled bigint prices.
 *
 * X = priceBase / priceQuote
 *
 * @param priceBase      bigint scaled by pricePrecision (e.g., *1e8)
 * @param priceQuote     bigint scaled by pricePrecision (same scale)
 * @param pricePrecision bigint precision of the prices (e.g., 8)
 * @param outPrecision   precision for returned rate (default = 8)
 *
 * @returns bigint scaled by outPrecision, or undefined
 */
export const calculateExchangeRateBigInt = (
  priceBase?: bigint | null,
  priceQuote?: bigint | null,
  pricePrecision?: number,
  outPrecision = 8,
): bigint | undefined => {
  if (priceBase == null || priceQuote == null || pricePrecision == null) {
    return undefined
  }

  if (priceQuote === 0n) return undefined

  // scaling for output precision
  const scale = 10n ** BigInt(outPrecision)
  if (scale === 0n) return undefined

  // ratio = (priceBase / 1eP) / (priceQuote / 1eP) = priceBase / priceQuote
  return (priceBase * scale) / priceQuote
}
